import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

const apiErrorStore = create(
  persist(
    (set) => ({
      errorInFetchingData: false,
      setErrorInFetchingData: (isError) =>
        set({ errorInFetchingData: isError }),
    }),
    {
      name: "errorInFetchingData-storage",
      storage: createJSONStorage(() => sessionStorage),
    }
  )
);

export default apiErrorStore;
